import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiNotificationHelperService } from '@fi-shared/fi-notification/fi-notification-helper.service';

@NgModule({
    imports: [CommonModule],
    declarations: [],
    providers: [FiNotificationHelperService],
})
export class FiNotificationSharedModule {}
